/**
 * Members for a group
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { Card, Tab, Tabs } from 'react-bootstrap';
import useMemoryState from 'utils/useMemoryState.js';
import getPathBase from '../../../getPathBase.js';
import messages from './messages.js';
import MemberType from './MemberType.jsx';
import useGroupTypes from '../../useGroupTypes.js';

function Members(props) {
  const { group } = props;
  const { groupType, members } = group;
  const [search, setSearch] = useMemoryState('adminMemberSearch', '');
  const intl = useIntl();
  const location = useLocation();
  const isAdmin = getPathBase() === 'admin';
  const match = /#(\w+)/.test(location.hash);
  const { addLabel, memberTypes } = useGroupTypes(groupType);
  const readOnly = !addLabel;
  const activeKey = (match?.[1]) || (isAdmin ? memberTypes[0].name : 'student');
  const handleSelect = (key) => { window.location.href = `#${key}`; };

  function getTitle(mType) {
    const name = intl.formatMessage(messages[mType.name]);
    if (members?.[mType.id]?.totalCount) {
      return `${name} (${members[mType.id].totalCount})`;
    }
    return name;
  }
  return (
    <Card>
      <Card.Body>
        <Tabs id="select-member-type" defaultActiveKey={activeKey} onSelect={handleSelect} className="socs-tabs">
          {memberTypes.map((mType) => (
            <Tab key={mType.name} eventKey={mType.name} title={getTitle(mType)}>
              <MemberType group={group} memberType={mType} readOnly={readOnly} search={search} setSearch={setSearch} />
            </Tab>
          ))}
        </Tabs>
      </Card.Body>
    </Card>
  );
}

Members.propTypes = {
  group: PropTypes.object,
};

export default Members;
